var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449,36H63C28.2,36,0,64.2,0,99v314c0,34.8,28.2,63,63,63h386c34.8,0,63-28.2,63-63V99C512,64.2,483.8,36,449,36z M158,417 c0,6.4-5.1,11.5-11.5,11.5h-97c-6.4,0-11.5-5.1-11.5-11.5V95c0-6.4,5.1-11.5,11.5-11.5h97c6.4,0,11.5,5.1,11.5,11.5V417z M316,226.5 c0,6.4-5.1,11.5-11.5,11.5h-97c-6.4,0-11.5-5.1-11.5-11.5V95c0-6.4,5.1-11.5,11.5-11.5h97c6.4,0,11.5,5.1,11.5,11.5V226.5z M474,354.5c0,6.4-5.1,11.5-11.5,11.5h-97c-6.4,0-11.5-5.1-11.5-11.5V95c0-6.4,5.1-11.5,11.5-11.5h97c6.4,0,11.5,5.1,11.5,11.5 V354.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Board.988e0edacf728d52f84175d254494ffc.svg";